import { Component } from '@angular/core';

@Component({
  imports: [],
  selector: 'app-activities',
  styleUrl: './activities.scss',
  templateUrl: './activities.html',
})
export class Activities {}
